
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import {
  DexAssessment,
  SummarySTTData
} from "@/domain/entities/PusatResolusiV2";
import { prop, Vue, Options } from "vue-class-component";
import ModalDexAssessment from "../components/modal-dex-assessment.vue";

class Props {
  isSummary = prop<boolean>({
    type: Boolean,
    default: false
  });
  detailData = prop<SummarySTTData>({
    type: SummarySTTData,
    required: true
  });
  dexAssessmentData = prop<DexAssessment[]>({
    type: Array,
    required: true
  });
}

@Options({
  components: {
    ModalDexAssessment
  }
})
export default class DelDexCodrej extends Vue.with(Props) {
  private isCollapsed = false;
  private showModalDex = false;

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }

  get lastStatusAt() {
    return this.formatDateTime(
      this.detailData.rejectReason
        ? this.detailData.lastDelivAt
        : this.detailData.updatedAt
    );
  }

  get isSttNumber(): boolean {
    return /^\d{1,2}LP\w+$/g.test(this.detailData.sttNo);
  }

  get decideEmptyAttempts() {
    return this.isSttNumber ? "0" : "-";
  }

  formatAttempt(attemptCount?: number): string {
    if (!attemptCount) return this.decideEmptyAttempts;
    const formatted = formatByCountry(attemptCount, { type: "quantity" });
    return `${formatted}x`;
  }

  handleShowDexModal() {
    this.showModalDex = !this.showModalDex;
  }
}
